/* eslint-disable import/extensions */
import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/Index';
import DeliverCert from '@/views/DeliverCert';
import DeliverRegister from '@/views/DeliverRegister';
import DeliverRequest from '@/views/DeliverRequest';
import DeliverRequestSuccess from '@/views/DeliverRequestSuccess';
import Information from '@/views/Information';
import Info from '@/views/Info';
import Detail from '@/views/Detail';
import infoDetail from '@/views/infoDetail';
import Delivery from '@/views/Delivery';
import Balance from '@/views/Balance';
import Ba from '@/views/Ba';
import Refund from '@/views/Refund';
import RefundDetail from '@/views/RefundDetail';
import FyiRefund from '@/views/FyiRefund';

Vue.use(Router);
/* eslint-disable */
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      // 2022.01.26. sykim: 불필요한 페이지 노출 방지를 위해서 리다이렉트 처리
      beforeEnter(to, from, next) {
        window.location.href = "https://www.giftiel.co.kr/";
      },
      name: 'Index',
      component: Index,
      meta:{ requiresAuth: false, title: 'Index'}
    },
        {
      path: '/fyi/refund',
      name: 'FyiRefund ',
      props: true,
      component: FyiRefund,
      meta:{ requiresAuth: false, title: '환불안내'},
    },
      {
      path: '/rfnd/detail/:key',
      name: 'RefundDetail',
      component: RefundDetail,
      meta:{ requiresAuth: false, title: '환불신청상세확인'},
    },
      {
      path: '/rfnd/:key',
      name: 'Refund',
      props: true,
      component: Refund,
      meta:{ requiresAuth: false, title: '환불안내'},
    },
    {
      path: '/:key',
      name: 'Detail',
      component: Detail,
      meta:{ requiresAuth: false, title: '이용안내'},
      beforeEnter: (to, from, next) => {
        if (to.params.key === undefined || to.params.key === null || to.params.key === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/deliver-cert/:pin',
      name: 'deliver-cert',
      component: DeliverCert,
      meta:{ requiresAuth: false, title: 'Giftiel 배송신청'},
      beforeEnter: (to, from, next) => {
        if (to.params.pin === undefined || to.params.pin === null || to.params.pin === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/deliver-register/:pin',
      name: 'deliver-register',
      props: true,
      component: DeliverRegister,
      meta:{ requiresAuth: false, title: 'Giftiel 배송신청'}
    },
    {
      path: '/deliver-request/:pin',
      name: 'deliver-request',
      props: true,
      component: DeliverRequest,
      meta:{ requiresAuth: false, title: 'Giftiel 배송신청'}
    },
    {
      path: '/deliver-success/:pin',
      name: 'deliver-success',
      props: true,
      component: DeliverRequestSuccess,
      meta:{ requiresAuth: false, title: 'Giftiel 배송신청'}
    },
    {
      path: '/information/:pin',
      name: 'information',
      component: Information,
      meta:{ requiresAuth: false, title: '이용안내'},
      beforeEnter: (to, from, next) => {
        if (to.params.pin === undefined || to.params.pin === null || to.params.pin === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/info/:key',
      name: 'info',
      component: Info,
      meta:{ requiresAuth: false, title: '이용안내'},
      beforeEnter: (to, from, next) => {
        if (to.params.key === undefined || to.params.key === null || to.params.key === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/info-detail/:key',
      name: 'info-detail',
      component: infoDetail,
      meta:{ requiresAuth: false, title: '이용안내'},
      beforeEnter: (to, from, next) => {
        if (to.params.key === undefined || to.params.key === null || to.params.key === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/delivery-search/:pin',
      name: 'delivery-search',
      component: Delivery,
      meta:{ requiresAuth: false, title: '배송조회'},
      beforeEnter: (to, from, next) => {
        if (to.params.pin === undefined || to.params.pin === null || to.params.pin === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/se/CP/:pin',
      name: 'seCp',
      component: Balance,
      meta:{ requiresAuth: false, title: '잔액조회'},
      beforeEnter: (to, from, next) => {
        if (to.params.pin === undefined || to.params.pin === null || to.params.pin === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/se/DH/:pin',
      name: 'seDh',
      component: Balance,
      meta:{ requiresAuth: false, title: '잔액조회'},
      beforeEnter: (to, from, next) => {
        if (to.params.pin === undefined || to.params.pin === null || to.params.pin === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    },
    {
      path: '/ba/:key',
      name: 'Ba',
      component: Ba,
      meta:{ requiresAuth: false, title: '잔액조회'},
      beforeEnter: (to, from, next) => {
        if (to.params.key === undefined || to.params.key === null || to.params.key === '') {
          alert('잘못된 경로로 접근하였습니다.\n수신하신 SMS/MMS에서 재시도 부탁드립니다.');
        }
        else next();
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js